import { render, staticRenderFns } from "./Accession.vue?vue&type=template&id=e1211354&scoped=true&"
import script from "./Accession.vue?vue&type=script&lang=js&"
export * from "./Accession.vue?vue&type=script&lang=js&"
import style0 from "./Accession.vue?vue&type=style&index=0&id=e1211354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1211354",
  null
  
)

export default component.exports